import React, { useMemo, FC } from 'react'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'

import withFullRoute from './hooks/withFullRoute'

import {
  APP_PALETTE,
  APP_PALETTE_DARK,
} from './settings'

const Theme: FC = (props) => {

  const fullRoute = withFullRoute()

  const theme = useMemo(() => {
    const palette = fullRoute?.options?.theme == 'dark' ? APP_PALETTE_DARK : APP_PALETTE
    return createMuiTheme({
      palette,
    })
  }, [
    fullRoute,
  ])

  console.dir(theme)
  
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      { props.children }
    </MuiThemeProvider>
  );
}

export default Theme